/**
 * Derives a human-friendly display version from release name and git ref.
 *
 * Priority:
 *   1. releaseName (e.g. "v5.03.0rc12", "v2026.04.13", "CFR_v2026.0413.2")
 *   2. Branch name stripped from gitRef (e.g. "feature/QDII-2068_enhance-version-info")
 *   3. PR number from gitRef (e.g. "PR #109")
 *   4. "local dev" when nothing is available
 */
export function deriveDisplayVersion(releaseName, gitRef) {
    if (releaseName) {
        return releaseName;
    }
    if (gitRef) {
        if (gitRef.startsWith("refs/heads/")) {
            return gitRef.substring("refs/heads/".length);
        }
        if (gitRef.startsWith("refs/pull/")) {
            const prPart = gitRef.substring("refs/pull/".length);
            const slashIdx = prPart.indexOf("/");
            const prNumber = slashIdx > 0 ? prPart.substring(0, slashIdx) : prPart;
            return "PR #" + prNumber;
        }
        return gitRef;
    }
    return "local dev";
}
